type CountBadgeProps = {
  count: number;
};

export const CountBadge = ({ count }: CountBadgeProps) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span className="t-absolute -t-top-1 -t-right-1 t-h-4 t-w-4 t-rounded-full t-bg-purple-10 t-flex t-items-center t-justify-center t-text-text-60 t-text-[10px] t-font-medium t-z-10 t-pointer-events-none">
      {count}
    </span>
  );
};
